import { render, staticRenderFns } from "./general-alert.vue?vue&type=template&id=c4369faa&scoped=true&"
import script from "./general-alert.vue?vue&type=script&lang=js&"
export * from "./general-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4369faa",
  null
  
)

export default component.exports